import { cn } from '@/lib/utils';

import { Input, InputFieldProps } from '../../atoms/Input';
import { InputDropdown, InputDropdownProps } from '../../atoms/InputDropdown';
import { Text } from '../../atoms/Text';
import { countries, Country } from './countries';

type TelephoneInputProps = {
  countryCodeProps: Omit<
    InputDropdownProps<Country & { value: string; label: string }>,
    'options' | 'renderOption' | 'renderSelectedValue'
  >;
  phoneNumberProps: InputFieldProps;
};

export const TelephoneInput = ({
  countryCodeProps,
  phoneNumberProps,
}: TelephoneInputProps) => {
  return (
    <div className='flex flex-row items-end gap-2'>
      <InputDropdown
        {...countryCodeProps}
        classNames={{
          ...countryCodeProps.classNames,
          root: cn('w-[108px]', countryCodeProps.classNames?.root),
        }}
        popoverProps={{
          classNames: {
            childrenWrapper: 'w-[280px] shadow-card',
          },
          contentProps: {
            avoidCollisions: true,
          },
        }}
        hasSearch
        options={countries.map((country) => ({
          ...country,
          label: `+${country.code} ${country.name}`,
          value: `+${country.code}`,
        }))}
        onOptionChange={countryCodeProps.onOptionChange}
        renderOption={({ option }) => (
          <div className='flex items-center gap-x-2.5'>
            <Text variant='body-m' classNames={{ wrapper: 'w-9 tabular-nums' }}>
              +{option.code}
            </Text>
            <Text variant='body-m' classNames={{ wrapper: 'text-gray-500' }}>
              {option.name}
            </Text>
          </div>
        )}
        renderSelectedValue={({ option }) => (
          <Text variant='body-m' classNames={{ wrapper: 'w-9 tabular-nums' }}>
            +{option.code}
          </Text>
        )}
      />
      <Input
        {...phoneNumberProps}
        classNames={{
          ...phoneNumberProps.classNames,
          root: cn('flex-grow', phoneNumberProps.classNames?.root),
        }}
      />
    </div>
  );
};
